
import qs from 'qs';

const loadScript = (scripts, cbs) => {
  const loaded = [...document.scripts];

  const createScriptTag = (src, cb) => new Promise((resolve, reject) => {
    let resolved = false;
    let notResolved = false;
    const body = document.getElementsByTagName('body')[0];
    const scriptTag = document.createElement('script');

    scriptTag.type = 'text/javascript';
    scriptTag.async = false;

    const handleLoaded = () => {
      resolved = true;
      cb(src);
    };

    const handleReject = () => {
      notResolved = true;
      reject(src);
    };

    const handleCallback = () => {
      if (resolved) return handleLoaded();
      if (notResolved) return handleReject();
      const state = scriptTag.readyState;
      if (state === 'complete') {
        handleLoaded();
      } else if (state === 'error') {
        handleReject();
      }
    };


    if (src.match(/callback=*/)) {
      const { callback } = qs.parse(src, { ignoreQueryPrefix: true });
      window[callback] = cb;
    } else {
      scriptTag.addEventListener('load', handleLoaded);
    }

    scriptTag.onreadystatechange = handleCallback;
    scriptTag.addEventListener('error', handleReject);
    scriptTag.src = src;
    body.appendChild(scriptTag);
    return scriptTag;
  });


  const loadSingleScripts = async (src, cb) => {
    for (let i = 0; i < loaded.length; i += 1) {
      if (loaded[i].getAttribute('src') === src) {
        return cb(src);
      }
    }

    try {
      await createScriptTag(src, cb);
    } catch (error) {
      return Promise.reject(src);
    }
  };

  const initLoading = () => {
    for (let i = 0; i < scripts.length; i += 1) {
      loadSingleScripts(scripts[i], cbs[i]);
    }
  };

  initLoading();
};

export default loadScript;
